<template>
 <div class="login-page">
 <div class="login-box">
 <div class="login-header">
 <div class="login-logo"><i class="el-icon-data-line"></i></div>
 <h2>网站流量统计平台</h2>
 <p>请登录后台管理系统</p>
 </div>
 <el-form ref="form" :model="form" :rules="rules" @submit.native.prevent="handleLogin">
 <el-form-item prop="username">
 <el-input
 v-model="form.username"
 prefix-icon="el-icon-user"
 placeholder="用户名"
 @keyup.enter.native="handleLogin"
 />
 </el-form-item>
 <el-form-item prop="password">
 <el-input
 v-model="form.password"
 prefix-icon="el-icon-lock"
 type="password"
 placeholder="密码"
 show-password
 @keyup.enter.native="handleLogin"
 />
 </el-form-item>
 <el-form-item>
 <el-button type="primary" :loading="loading" @click="handleLogin" style="width:100%">
 登 录
 </el-button>
 </el-form-item>
 </el-form>
 </div>
 <div class="login-footer">Powered by TRAE</div>
 </div>
</template>

<script>
import { authApi } from '../api';

export default {
 name: 'Login',
 data() {
 return {
 form: { username: '', password: '' },
 rules: {
 username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
 password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
 },
 loading: false
 };
 },
 methods: {
 handleLogin() {
 this.$refs.form.validate(async valid => {
 if (!valid) return;
 this.loading = true;
 try {
 const res = await authApi.login(this.form);
 if (res.code === 0) {
 localStorage.setItem('wt_token', res.data.token);
 localStorage.setItem('wt_user', JSON.stringify(res.data.user));
 this.$message.success('登录成功');
 this.$router.push('/');
 } else {
 this.$message.error(res.msg);
 }
 } catch (e) {
 this.$message.error('登录失败，请检查网络');
 } finally {
 this.loading = false;
 }
 });
 }
 }
};
</script>

<style scoped>
.login-page {
 height: 100vh;
 display: flex;
 flex-direction: column;
 align-items: center;
 justify-content: center;
 background: linear-gradient(135deg, #1e2a3a 0%, #25324a 50%, #1a2538 100%);
 position: relative;
 overflow: hidden;
}

.login-page::before {
 content: '';
 position: absolute;
 top: -50%; left: -50%;
 width: 200%; height: 200%;
 background: radial-gradient(circle at 30% 50%, rgba(91,141,239,0.06) 0%, transparent 50%),
 radial-gradient(circle at 70% 30%, rgba(91,141,239,0.03) 0%, transparent 50%);
}

.login-box {
 width: 400px;
 padding: 44px 40px 36px;
 background: #fff;
 border-radius: 16px;
 box-shadow: 0 16px 48px rgba(0,0,0,0.25);
 position: relative;
 z-index: 1;
}

.login-header {
 text-align: center;
 margin-bottom: 32px;
}

.login-logo {
 width: 64px; height: 64px;
 margin: 0 auto 16px;
 border-radius: 16px;
 background: linear-gradient(135deg, #5b8def 0%, #4a7de0 100%);
 display: flex; align-items: center; justify-content: center;
 font-size: 32px; color: #fff;
 box-shadow: 0 4px 16px rgba(91,141,239,0.25);
}

.login-header h2 {
 font-size: 22px;
 color: #1e293b;
 margin: 0 0 6px;
 font-weight: 600;
}

.login-header p {
 font-size: 14px;
 color: #64748b;
 margin: 0;
}

.login-footer {
 position: absolute;
 bottom: 24px;
 font-size: 12px;
 color: rgba(255,255,255,0.25);
 z-index: 1;
}
</style>